<template>
    <div class="card">
        <div class="btn-row card-header d-flex justify-content-between mb-0">
            <div>
                <span class="mr-4"><i class="fe fe-bookmark mr-2"></i>{{ annualPlanGoal.plan.name.toUpperCase() }}<span v-if="hasPackages" class="badge badge-secondary ml-2">{{ annualPlanGoal.plan.package.name[lang] }}</span></span>
                <button class="btn-edit btn btn-link px-2" v-if="userRole == 'pengurus cawangan'" type="button" data-toggle="modal" :data-target="'#modalUpdateAnnualPlan-'+annualPlanGoal.id">Edit</button>
                <button class="btn-delete btn btn-link px-2" v-if="userRole == 'pengurus cawangan'" type="button" @click="deletePlanGoal()">Delete</button>
                <span class="mr-4" v-if="userRole == 'pentadbir cawangan'"><i class="fe fe-dollar-sign mr-2"></i>{{ annualPlanGoal.target_collection }}</span>
                <span v-if="userRole == 'pentadbir cawangan'"><i class="fe fe-user mr-2"></i>{{ annualPlanGoal.user.name.toUpperCase() }}</span>
            </div>
            <div v-if="userRole == 'pengurus cawangan'">
                <span class=""><i class="fe fe-dollar-sign mr-2"></i>{{ annualPlanGoal.target_collection }}</span>
                <span class="ml-6"><i class="fe fe-user mr-2"></i>{{ annualPlanGoal.user.name.toUpperCase() }}</span>
            </div>
            <div v-if="userRole == 'pentadbir cawangan'">
                <div v-if="hasLocation">
                    <button class="btn btn-secondary btn-sm" type="button" data-toggle="modal" :data-target="'#modalAddGoalLocation-'+annualPlanGoal.id"><i class="fe fe-plus mr-2"></i>Goal Location</button>
                </div>
                <div class="dropdown" v-if="!childGoals.length">
                    <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" id="dropdownMenu" data-toggle="dropdown">Add Goal</button>
                    <div class="dropdown-menu dropdown-menu-right">
                        <button class="dropdown-item text-sm" type="button" @click="addMonthlyPlanGoal()">Plan</button>
                        <button class="dropdown-item text-sm" type="button" data-toggle="modal" :data-target="'#modalAddGoalLocation-'+annualPlanGoal.id">Location</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="childGoals.length">
<!-- monthly plan card -->
            <div class="btn-row card-body pt-0" v-if="!hasLocation">
                <div class="row mb-1">
                    <button class="btn-delete btn btn-link px-2" type="button" @click="deleteMonthlyPlan()">Delete</button>
                </div>
                <div class="row mb-1">
                    <div class="col-1 text-sm" v-for="(month, index) in months">{{ month }}</div>
                </div>
                <div class="row">
                    <div class="col-1" v-for="(month, index) in months">
                        <input type="number" min="0" class="form-control" :name="'goal['+childGoals.find(goal => getMonthFromGoal(goal) == index).id+']'" :value="childGoals.find(goal => getMonthFromGoal(goal) == index) ? childGoals.find(goal => getMonthFromGoal(goal) == index).target_collection : 0">
                    </div>
                </div>
            </div>
<!-- monthly location card -->
            <div v-if="hasLocation">
                <div class="btn-row card-body pt-2" v-for="locationGoal in locationGoals">
                    <div>
                        <div class="px-0 mb-1 col-4">
                            <i class="fe fe-map-pin mr-2"></i><span class="badge badge-secondary mr-2">{{ locationGoal.location.name }}</span>
                            <button class="btn-edit btn btn-link px-1" type="button" data-toggle="modal" :data-target="'#modalUpdateMonthlyLocation-'+locationGoal.id">Edit</button>
                            <button class="btn-delete btn btn-link px-1" type="button" @click="deleteMonthlyLocationGoal(locationGoal.location.id)">Delete</button>
                        </div>
                    </div>
                    <div>
                        <div class="row mb-1">
                            <div class="col-1 text-sm" v-for="(month, index) in months">{{ month }}</div>
                        </div>
                        <div class="row">
                            <div class="col-1" v-for="(month, index) in months">
                                <input type="number" min="0" class="form-control" :name="'goal['+getMonthlyLocationGoal(childGoals, locationGoal.location_id).find(goal => getMonthFromGoal(goal) == index).id+']'" :value="getMonthlyLocationGoal(childGoals, locationGoal.location_id).find(goal => getMonthFromGoal(goal) == index) ? getMonthlyLocationGoal(childGoals, locationGoal.location_id).find(goal => getMonthFromGoal(goal) == index).target_collection : '0.00'">
                            </div>
                        </div>
                    </div>
<!-- Modal Update Monthly Location -->
                    <form>
                        <div class="modal fade" :id="'modalUpdateMonthlyLocation-'+locationGoal.id" tabindex="-1" role="dialog">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="modalLabel">UPDATE LOCATION</h5>
                                        <button type="button" class="close" data-dismiss="modal"></button>
                                    </div>
                                    <div class="modal-body">
                                        <div class="row mb-3 mx-2">
                                            <div class="input-group">
                                                <span class="input-group-prepend">
                                                    <span class="input-group-text"><i class="fe fe-map-pin"></i></span>
                                                </span>
                                                <input type="text" class="form-control" name="location" v-model="locationGoal.location.name" required>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn-cancel btn btn-link" data-dismiss="modal">Cancel</button>
                                        <button type="button" class="btn btn-primary" @click="updateMonthlyLocationGoal(locationGoal.location.id, locationGoal.location.name)">Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div v-if="!childGoals.length">
            <div class="text-center">
                <h4 class="my-2"><span class="badge badge-warning">NO GOAL</span></h4>
            </div>
        </div>
<!-- Modal Add Monthly Location -->
        <form>
            <div class="modal fade" :id="'modalAddGoalLocation-'+annualPlanGoal.id" tabindex="-1" role="dialog">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="modalLabel">ADD LOCATION</h5>
                            <button type="button" class="close" data-dismiss="modal"></button>
                        </div>
                        <div class="modal-body">
                            <div class="mb-3">
                                <input type="text" class="form-control" name="location" placeholder="Type location name" v-model="locationName" required>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn-cancel btn btn-link" data-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-primary" @click="addMonthlyLocationGoal()">Proceed</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
<!-- Modal Update Annual Plan -->
        <form>
            <div class="modal fade" :id="'modalUpdateAnnualPlan-'+annualPlanGoal.id" tabindex="-1" role="dialog">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="modalLabel">UPDATE PLAN</h5>
                            <button type="button" class="close" data-dismiss="modal"></button>
                        </div>
                        <div class="modal-body">
                            <div class="mb-3">
                                <input type="text" class="form-control" name="name" v-model="annualPlanGoal.plan.name" required>
                            </div>
                            <div class="mb-3">
                                <div class="input-group">
                                    <span class="input-group-prepend">
                                        <span class="input-group-text">RM</span>
                                    </span>
                                    <input type="text" class="form-control" name="target_collection" v-model="annualPlanGoal.target_collection">
                                </div>
                            </div>
                            <div v-if="hasPackages" class="mb-3">
                                <select class="form-control" name="package" v-model="annualPlanGoal.plan.package_id">
                                    <option :value="campaignPackage.id" v-for="campaignPackage in campaignPackages" :selected="annualPlanGoal.plan.package_id == campaignPackage.id">{{ campaignPackage.name[lang].toUpperCase() }}</option>
                                </select>
                            </div>
                            <div class="mb-3">
                                <select class="form-control" name="pic" v-model="annualPlanGoal.user.id">
                                    <option :value="user.id" v-for="user in users" :selected="annualPlanGoal.user.id == user.id">{{ user.name.toUpperCase() }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn-cancel btn btn-link" data-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-primary" @click="updatePlanGoal()">Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>

</template>

<script>
    import Moment from 'moment';
    export default {
        data() {
            return {
                annualPlanGoal: this.initAnnualPlanGoal,
                childGoals: this.initAnnualPlanGoal.goals,
                months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                monthlyPlanGoal: null,
                monthlyLocationGoal: null,
                locationName: null,
                hasLocation: this.goalHasLocation,
                locationGoals: null,
                hasPackages: false,
            };
        },
        props: [
            'lang',
            'initAnnualPlanGoal',
            'userRole',
            'goalHasLocation',
            'locations',
            'year',
            'monthlyPlanId',
            'monthlyLocationId',
            'users',
            'campaignPackages'
        ],
        computed: {

        },
        methods: {
            getMonthFromGoal(goal) {
                return moment(goal.date.substr(0,7)).month();
            },
            getLocationGoal(goals) {
                var result = goals
                    .filter(goal => goal.goal_type_id == this.monthlyLocationId && goal.year == this.year)
                    .reduce((carry, goal) => {
                        carry[goal.location.name] = goal;
                        return carry;
                    }, []);

                return Object.values(result);
            },
            getMonthlyLocationGoal(goals, locationId) {
                return goals.filter(goal => goal.goal_type_id == this.monthlyLocationId && goal.year == this.year && goal.location_id == locationId);
            },
            addMonthlyPlanGoal() {
                this.monthlyPlanGoal = {
                    year: this.year,
                    goal_type_id: this.monthlyPlanId,
                    campaign_id: this.annualPlanGoal.campaign_id,
                    annual_plan_id: this.annualPlanGoal.id,
                    months: this.months,
                }

                return axios.post(route('pdca.performances.branch.monthly-plan.store'), 
                    this.monthlyPlanGoal
                )
                    .then((response) => {
                        this.childGoals = response.data;
                        toastr.success('Plan Goal Added');
                    })
                    .catch((error) => {
                        console.log('error adding plan goal', error);
                    });
            },
            deleteMonthlyPlan() {
                const options = {title: 'Confirmation Alert', cancelLabel: 'Cancel', okLabel: 'Proceed'}
                this.$dialogs.confirm('Are you sure want to delete this goal?', options)
                .then(res => {
                    if (res.ok) {
                        return axios.delete(route('pdca.performances.branch.monthly-goal.destroy', { goal: this.annualPlanGoal.id }))
                            .then((response) => {
                                window.location.href = '/performances/branch/campaigns/'+this.annualPlanGoal.campaign_id+'?year='+this.year;
                            })
                            .catch((error) => {
                                console.log('error deleting goal', error);
                            });
                    }
                })
            },
            addMonthlyLocationGoal() {
                if (this.locationName != null) {
                    this.monthlyLocationGoal = {
                        location_name: this.locationName,
                        year: this.year,
                        goal_type_id: this.monthlyLocationId,
                        campaign_id: this.annualPlanGoal.campaign_id,
                        annual_plan_id: this.annualPlanGoal.id,
                        months: this.months,
                    }

                    return axios.post(route('pdca.performances.branch.monthly-location.store'), 
                        this.monthlyLocationGoal
                    )
                        .then((response) => {
                            this.childGoals = response.data;
                            this.initData();
                            this.hasLocation = true;
                            this.locationName = null;
                            toastr.success('Location Goal Added');
                            $('#modalAddGoalLocation-'+this.annualPlanGoal.id).modal('hide');
                        })
                        .catch((error) => {
                            console.log('error adding location goal', error);
                        });
                } else {
                    toastr.error('Location Name Empty');
                }
            },
            updateMonthlyLocationGoal(locationId, locationName) {
                if (locationName != '') {
                    return axios.put(route('pdca.performances.branch.monthly-location.update'),
                        {
                            annual_plan_id: this.annualPlanGoal.id,
                            locationId: locationId,
                            locationName: locationName,
                        }
                    )
                        .then((response) => {
                            this.childGoals = response.data;
                            this.initData();
                            toastr.success('Location Updated');
                            $('.modal').modal('hide');
                        })
                        .catch((error) => {
                            console.log('error updating location', error);
                        });
                } else {
                    toastr.error('Location Name Empty');
                }
            },
            deleteMonthlyLocationGoal(locationId) {
                const options = {title: 'Confirmation Alert', cancelLabel: 'Cancel', okLabel: 'Proceed'}
                this.$dialogs.confirm('Are you sure want to delete this location?', options)
                .then(res => {
                    if (res.ok) {
                        return axios.delete(route('pdca.performances.branch.monthly-location.destroy', { locationId: locationId }))
                            .then((response) => {
                                window.location.href = '/performances/branch/campaigns/'+this.annualPlanGoal.campaign_id+'?year='+this.year;
                            })
                            .catch((error) => {
                                console.log('error deleting location', error);
                            });
                    }
                })
            },
            updatePlanGoal() {
                return axios.put(route('pdca.performances.branch.update'),
                    {
                        goalId: this.annualPlanGoal.id,
                        name: this.annualPlanGoal.plan.name,
                        target_collection: this.annualPlanGoal.target_collection,
                        picId: this.annualPlanGoal.user.id,
                        package: this.annualPlanGoal.plan.package_id,
                    }
                )
                    .then((response) => {
                        this.annualPlanGoal = response.data;
                        window.location.href = '/performances/branch/campaigns/'+this.annualPlanGoal.campaign_id+'?year='+this.year;

                    })
                    .catch((error) => {
                        console.log('error updating plan', error);
                    });
            },
            deletePlanGoal() {
                const options = {title: 'Confirmation Alert', cancelLabel: 'Cancel', okLabel: 'Proceed'}
                this.$dialogs.confirm('Are you sure want to delete this plan?', options)
                .then(res => {
                    if (res.ok) {
                        return axios.delete(route('pdca.performances.branch.destroy', { goal: this.annualPlanGoal.id }))
                            .then((response) => {
                                window.location.href = '/performances/branch/campaigns/'+this.annualPlanGoal.campaign_id+'?year='+this.year;
                            })
                            .catch((error) => {
                                console.log('error deleting plan', error);
                            });
                    }
                })
            },
            initData() {
                this.locationGoals = this.getLocationGoal(this.childGoals);

                if (this.annualPlanGoal.plan.package) {
                    this.hasPackages = true;
                }
            },
        },
        mounted() {
            this.initData();

            $(function(){
                $('input[type="number"]').change(function(){
                 this.value = parseFloat(this.value).toFixed(2);
             });
            });
        }
    }
</script>